import { StrictMode } from 'react';
import { Providers } from '@/providers';
import { ConfigProvider } from '@/contexts/ConfigContext';
import { StandaloneAppConfig } from '@/StandaloneAppConfig';

interface AppProps {
  config?: StandaloneAppConfig;
}

function App({ config }: AppProps) {
  return (
    <StrictMode>
      <ConfigProvider config={config}>
        <Providers>{/* add new content */}</Providers>
      </ConfigProvider>
    </StrictMode>
  );
}

export default App;
